<template>
  <div class="w-100 bg-white">
    <div id="search-room"></div>
    <SearchRoomHeader />

    <!-- ROOM -->
    <div
      class="ga-container fluid mb-5 bg-white position-relative"
      v-if="
        iActiveHotelModuleRoom || getMerchant.additional_appearance === 'CART'
      ">
      <div
        id="search-room-middle"
        class="position-absolute"
        style="top: -130px; left: 0px"></div>
      <HotelRoomFilterGeneral
        v-if="$is_tablet_lower_view"
        :total-room-result="totalRoomResult"
        @loadRoomList="loadRoomListFromFilter" />
      <div class="row mb-5">
        <div class="col-12 col-lg-9 order-2 order-lg-1">
          <HotelRoomFilterGeneral
            v-if="!$is_tablet_lower_view"
            :total-room-result="totalRoomResult"
            @loadRoomList="loadRoomListFromFilter" />

          <div class="w-100 position-relativei">
            <div
              id="search-room-result"
              class="position-absolute"
              style="top: -420px; left: 0px" />
          </div>
          <b-skeleton-wrapper :loading="room.isLoading">
            <template #loading>
              <template v-if="$is_mobile_view">
                <b-card body-class="p-0" class="mb-4" v-for="i in 2" :key="i">
                  <b-skeleton-img
                    no-aspect
                    width="100%"
                    height="150px"
                    card-img="top" />
                  <b-card-body>
                    <div class="mb-2">
                      <b-skeleton width="80%" height="25px" />
                    </div>
                    <b-row class="slim-grid-row">
                      <b-col cols="3">
                        <b-skeleton width="100%" height="20px" />
                      </b-col>
                      <b-col cols="3">
                        <b-skeleton width="100%" height="20px" />
                      </b-col>
                    </b-row>
                    <b-row class="slim-grid-row">
                      <b-col cols="3">
                        <b-skeleton width="80%" height="20px" />
                      </b-col>
                      <b-col cols="3" offset="6">
                        <b-skeleton width="100%" height="20px" />
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </template>
              <template v-else>
                <b-row class="mb-2" v-for="i in 2" :key="i">
                  <b-col cols="4">
                    <b-card body-class="p-0">
                      <b-skeleton-img
                        no-aspect
                        width="100%"
                        height="160px"
                        card-img="top" />
                      <b-card-body>
                        <div class="mb-2">
                          <b-skeleton width="80%" height="30px" />
                        </div>
                        <b-row class="slim-grid-row">
                          <b-col cols="3">
                            <b-skeleton width="100%" height="20px" />
                          </b-col>
                          <b-col cols="3">
                            <b-skeleton width="100%" height="20px" />
                          </b-col>
                        </b-row>
                        <b-skeleton width="30%" height="20px" class="my-2" />
                        <b-row class="slim-grid-row">
                          <b-col cols="3" offset="9">
                            <b-skeleton width="100%" height="37px" />
                          </b-col>
                        </b-row>
                      </b-card-body>
                    </b-card>
                  </b-col>
                  <b-col cols="8">
                    <div class="w-100 mb-3" v-for="j in 2" :key="j">
                      <b-card body-class="p-3">
                        <b-row>
                          <b-col cols="6">
                            <b-skeleton
                              width="100%"
                              height="30px"
                              class="mb-2" />
                            <b-skeleton
                              width="50%"
                              height="15px"
                              class="mb-2" />
                            <b-skeleton
                              width="30%"
                              height="15px"
                              class="mb-2" />
                            <b-skeleton
                              width="40%"
                              height="15px"
                              class="mb-2" />
                            <b-skeleton
                              width="20%"
                              height="20px"
                              class="mb-0" />
                          </b-col>
                          <b-col cols="6">
                            <b-skeleton
                              width="40%"
                              height="30px"
                              class="ml-auto" />
                            <b-skeleton
                              width="15%"
                              height="15px"
                              class="ml-auto" />
                            <b-skeleton
                              width="45%"
                              height="15px"
                              class="ml-auto mb-2" />
                            <b-skeleton
                              width="35%"
                              height="30px"
                              class="ml-auto" />
                            <b-skeleton
                              width="15%"
                              height="15px"
                              class="ml-auto" />
                          </b-col>
                        </b-row>
                      </b-card>
                    </div>
                  </b-col>
                </b-row>
              </template>
            </template>

            <div class="w-100">
              <template v-if="room.list.length == 0">
                <div class="text-center py-4 mb-2">
                  <img src="../../../assets/img/icon/404.png" width="200" />
                  <template v-if="$isNotEmptyV2(room.error)">
                    <p class="mb-1 mt-3 body-2-2 text-22 font-bold">
                      {{ room.error }}
                    </p>
                    <p class="mb-1 mt-3 body-2-2 text-22 font-bold">
                      {{ $t('hotel.error.404') }}
                    </p>
                  </template>
                  <p class="mb-3 body-2-2 font-semibold">
                    {{ $t('hotel.error.404-desc') }}
                  </p>
                  <button
                    class="button-primary bg-white px-4 text-black"
                    @click="resetAllFilter()">
                    {{ $t('hotel.filter.reset-filter') }}
                  </button>
                </div>
              </template>

              <div class="w-100" v-else>
                <div class="w-100" v-if="$is_mobile_view">
                  <template v-for="(type, index) in room.list">
                    <BeRoomMobile
                      @room_type_detail="toggleRoomTypeDetail"
                      @room_rate_detail="toggleRoomRateDetail"
                      @room_rate_add="toggleRoomRateAdd"
                      @more_room="openMoreRoomInput"
                      design-type="NEW"
                      :rt_hightlight_index="roomRateHighlightIndex"
                      :roomRateHighlight="roomRateHighlight"
                      :data="type"
                      :type_index="index"
                      :type_avlb="getRoomAvlb(type.id)"
                      :header_scroll="false"
                      :selected_room_rate="roomRateDetail"
                      :type="mobilePopupType" />
                  </template>
                </div>
                <div v-else class="bg-light-desktop p-2 rounded-4">
                  <template v-for="(type, index) in room.list">
                    <BeRoomDesktop
                      @room_type_detail="toggleRoomTypeDetail"
                      @toggleRateBreakdown="toggleRateBreakdown"
                      @toggleBookingRate="toggleBookingRate"
                      @toggleBookingRateCart="toggleBookingRateCart"
                      @handlePopupFilter="toggleBackdrop"
                      :rt_hightlight_index="roomRateHighlightIndex"
                      :roomRateHighlight="roomRateHighlight"
                      :type="type"
                      :type_index="index"
                      :type_avlb="getRoomAvlb(type.id)"
                      :is_active="getBeSortBy"
                      :discountAccumulation="discountAccumulation"
                      :totalRateBreakdown="totalRateBreakdown"
                      :is_booking_dropdown="is_booking_dropdown"
                      :show_rate="show_rate"
                      :show_rate_breakdown="show_rate_breakdown">
                    </BeRoomDesktop>
                  </template>
                </div>
              </div>
            </div>
          </b-skeleton-wrapper>
        </div>

        <div class="col-12 col-lg-3 order-1 order-lg-2 position-relative">
          <div
            v-if="$isNotEmptyV2(publicPromoCodeWithBanner)"
            class="w-100 mb-4">
            <flickity ref="flickity" :options="$fullSliderOption">
              <div
                class="carousel-cell w-100"
                :id="promoCodeBanner.id"
                v-for="promoCodeBanner in publicPromoCodeWithBanner">
                <div
                  class="w-100 radius-8 overflow-hidden"
                  style="height: 200px">
                  <img
                    :src="promoCodeBanner.popup_image"
                    @click="selectPromoCode(promoCodeBanner)"
                    class="img-fit" />
                </div>
              </div>
            </flickity>
          </div>
          <PotentialPromotion
            v-if="getMerchant.search_room_is_show_promotion_highlight" />
          <div :class="{ 'preview-cart-desktop': !$is_tablet_lower_view }">
            <SearchPreviewCart module="ADDITIONAL" />
          </div>

          <ClaimingReward wrapper_class="mt-5" />
        </div>
      </div>
    </div>

    <!-- ADDITIONAL SERVICE -->
    <div
      class="ga-container fluid bg-white"
      v-if="
        !iActiveHotelModuleRoom &&
        getMerchant.additional_appearance === 'SEARCH_ROOM'
      ">
      <div class="row mb-5">
        <div class="col-12 col-lg-9">
          <div class="w-100 mb-5">
            <HotelProductTab />
          </div>
          <AdditionalModule />
        </div>
        <div class="col-12 col-lg-3 order-1 order-lg-2 position-relative">
          <div
            :class="{ 'preview-cart-module-desktop': !$is_tablet_lower_view }">
            <SearchPreviewCart module="ADDITIONAL" />
          </div>
        </div>
      </div>
    </div>

    <Footer />

    <!-- ROOM TYPE DETAIL -->
    <transition name="fade">
      <roomTypeDetailDesktop
        v-if="$isNotEmptyV2(roomTypeDetail) && !$is_mobile_view"
        @detailRoom="toggleRoomTypeDetail()"
        @handlePopupFilter="toggleBackdrop"
        :detail_room_type="roomTypeDetail" />

      <roomTypeDetailMobile
        v-if="$isNotEmptyV2(roomTypeDetail) && $is_mobile_view"
        @closeDetailRoom="toggleRoomTypeDetail()"
        :data="roomTypeDetail" />

      <roomRateDetail
        v-if="
          $isNotEmptyV2(roomRateDetail) &&
          mobilePopupType === 'room_rate' &&
          $is_mobile_view"
        :more_room_form="showMoreRoomSelection"
        :show-more-room-only="getMerchant.search_room_is_show_room_rate_detail"
        :data="roomRateDetail"
        @close="toggleRoomRateDetail" />
    </transition>

    <!-- General Backdrop -->
    <transition name="fade">
      <PopUpBackground
        v-if="isBackdropActive"
        @handlePopupFilter="toggleBackdrop"
        :data="isBackdropActive"></PopUpBackground>
    </transition>
  </div>
</template>

<script>
import { get } from '@/services/index.js';
import { mapGetters, mapMutations } from 'vuex';
import SearchRoomHeader from '../../../components/hotel/be/SearchRoomHeader.vue';
import AdditionalModule from '../../../components/hotel/be/AdditionalModule.vue';
import BeRoomDesktop from '@/components/hotel/be/desktop/room';
import BeRoomMobile from '@/components/hotel/be/mobile/room';
import SearchPreviewCart from '../../../components/hotel/be/SearchPreviewCart.vue';
import PotentialPromotion from '@/components/hotel/be/PotentialPromotion.vue';
import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';
import Footer from '@/components/hotel/Footer';
import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
import roomTypeDetailDesktop from '@/components/hotel/be/desktop/roomTypeDetail';
import roomTypeDetailMobile from '@/components/hotel/be/mobile/roomTypeDetail';
import roomRateDetail from '@/components/hotel/be/mobile/roomRateDetail';
import HotelRoomFilterGeneral from '../../../components/hotel/be/HotelRoomFilterGeneral.vue';
import HotelProductTab from '../../../components/hotel/HotelProductTab.vue';
import { trackEvent } from '../../../utils/analytics';

export default {
  props: ['promoCodePopup'],
  components: {
    SearchRoomHeader,
    AdditionalModule,
    BeRoomDesktop,
    BeRoomMobile,
    SearchPreviewCart,
    PotentialPromotion,
    ClaimingReward,
    Footer,
    PopUpBackground,
    roomTypeDetailDesktop,
    roomTypeDetailMobile,
    roomRateDetail,
    HotelRoomFilterGeneral,
    HotelProductTab,
  },
  data() {
    return {
      room: {
        isLoading: true,
        error: '',
        list: [],
        typeAvailabilty: [],
      },
      isBackdropActive: false,
      roomTypeDetail: {},
      roomRateDetail: {},
      show_rate: false,
      show_rate_breakdown: false,
      is_booking_dropdown: false,
      is_booking_rate_cart: [],
      showMoreRoomSelection: false,
      mobilePopupType: '',
    };
  },
  computed: {
    ...mapGetters([
      'getMerchant',
      'iActiveHotelModuleRoom',
      'getBeFilter',
      'getBeSortBy',
      'getBePrice',
      'getCurrentLanguage',
      'getMembershipReferral',
      'getMembershipRewardApplied',
      'isNotLogin',
      'getBeFilterDetail',
      'getBeSortBy',
      'getBeRoomAvbl',
      'getSelectedPromotion',
      'getCurrentUser'
    ]),
    showSpecificFilter() {
      return this.$isNotEmptyV2(this.getBeFilterDetail.data);
    },
    roomRateHighlightIndex() {
      return this.room.list.findIndex((room) => {
        const match = this.getBeRoomAvbl.find((r) => r.id === room.id);
        return match ? match.original_availability > 0 : false;
      });
    },
    roomRateHighlight() {
      if (!this.room.list) return { roomTypeIndex: -1, roomRateIndex: -1 };

      let roomRateIndex = -1;

      const roomTypeIndex = this.room.list.findIndex((room) => {
        const availableRoom = this.getBeRoomAvbl.find(
          (avbl) => avbl.id === room.id
        );
        const isAvailable = availableRoom
          ? availableRoom.original_availability > 0
          : false;

        if (!isAvailable || roomRateIndex !== -1) return false;

        const index = room.room_rate.findIndex((rate) => rate.bookable);
        const hasBookableRate = index !== -1;

        if (hasBookableRate) {
          roomRateIndex = index;
          return true;
        }

        return false;
      });

      return { roomTypeIndex, roomRateIndex };
    },
    publicPromoCodeWithBanner() {
      if (this.$isEmpty(this.promoCodePopup)) return [];

      return this.promoCodePopup.filter((promo) =>
        this.$isNotEmptyV2(promo.popup_image)
      );
    },
    totalRoomResult() {
      if (this.$isEmpty(this.room.list)) return 'Find the best option';

      const roomType = this.room.list.length;
      const roomRate = this.room.list.reduce((accumulation, currentValue) => {
        const totalRoomRate = currentValue.room_rate.length;
        return accumulation + totalRoomRate;
      }, 0);

      return `${roomRate} ${this.$pluralWord(roomRate, 'room offer')}`;
    },
    selectedPromotion() {
      const promotion = this.getSelectedPromotion;
      if (!promotion) return '';
      return promotion.id;
    }
  },
  watch: {
    selectedPromotion() {
      if(!this.room.isLoading) {
        this.scrollToLoadedRoom();
        const validatePromotion = this.$isNotEmptyV2(this.selectedPromotion);
        this.loadRoomList(validatePromotion);
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.$smoothScroll('search-room');
    }, 200);
    this.loadRoomList();
  },
  methods: {
    ...mapMutations([
      'resetBeFilter',
      'resetSelectedPromotion',
      'setBeRoomAvbl',
      'setBeFilterDetail',
      'setSpecificBeFilter',
      'BeManipulateRoomRate',
    ]),
    scrollToLoadedRoom(){
      const selectedElement = `search-room-${this.$is_mobile_view ? 'result' : 'middle'}` 
      this.$smoothScroll(selectedElement);
    },
    loadRoomListFromFilter() {
      this.postLog();
      this.BeManipulateRoomRate('reset');
      this.scrollToLoadedRoom()
      this.loadRoomList();
    },
    postLog() {
      this.$postLog('SEARCH', 'Clicked Search');
      if (this.$isEmpty(this.getMerchant.google_analytics_id)) return;
      this.$gtag('event','search', { method: 'Google' });
    },
    async loadRoomList(validateSelectedPromotion = false) {
      try {
        this.room = {
          isLoading: true,
          error: '',
          list: [],
          typeAvailabilty: [],
        };
        const apiParams = this.getParamsRoomList(validateSelectedPromotion);
        const apiResponse = await get('CORE_HOTEL', 'search-room', apiParams);
        const { success, message, data, room_type_availability } =
          apiResponse.data;

        if (!success) throw new Error(message);

        trackEvent('view_item_list', {
          params: apiParams,
          result: data
        })
        this.parsedRoomData(data, room_type_availability);
        if(this.$isNotEmptyV2(data) && this.$isNotEmptyV2(this.getMerchant.google_tag_manager_id)) this.sendUserGuestData(data[0], apiParams)
        this.$sendEventMetaConversionsAPI('Search');
      } catch (error) {
        this.room.error = error.message;
      } finally {
        this.room.isLoading = false;
      }
    },
    sendUserGuestData(bestRoom, filter){
      const { check_in_date: checkIn, check_out_date: checkOut, adult, child, infant } = filter;
      const bestRoomRate = bestRoom.room_rate[0];
      const params = { checkIn, checkOut, adult, child, infant,
        room: bestRoom.name,
        roomRate: bestRoomRate.name,
        bestPrice: bestRoomRate.dates.reduce((acc, value) => acc + value.final_price, 0)
      }
       
      this.$sendHotelUserGuestDataLayer("availability", params);
    },
    getParamsRoomList(validateSelectedPromotion) {
      try {
        const promotion = this.getParamsRoomListPromotion(validateSelectedPromotion);
        const stayDate = this.getParamsRoomListStayDate();
        const guests = this.getParamsRoomListGuest();
        const price = this.getParamsRoomListPrice();
        const membership = this.getParamsRoomListMembership();
        const specificFilter = this.getParamsRoomListSpecificFilter();

        return {
          ...promotion,
          ...stayDate,
          ...guests,
          ...price,
          ...membership,
          ...specificFilter,
          merchant_id: this.getMerchant.id,
          sort_by: this.getBeSortBy,
          language_code: this.getCurrentLanguage,
          device: 'desktop',
        };
      } catch (error) {
        throw error;
      }
    },
    getParamsRoomListPromotion(validateSelectedPromotion) {
      let params = { use_promotion_combine: true };
      const {
        promo_code,
        date: { check_in: startDate, check_out: endDate },
      } = this.getBeFilter;
      
      if (!validateSelectedPromotion && this.$isNotEmptyV2(promo_code)) {
        params.promo_code = promo_code;
        this.resetSelectedPromotion()
      }

      const isPromoCodeEmpty = this.$isEmpty(params.promo_code)
      const isPromoCodeMatch = this.$isNotEmptyV2(this.getSelectedPromotion.promo_code) && promo_code === this.getSelectedPromotion.promo_code;

      if(isPromoCodeEmpty || isPromoCodeMatch){
        const selected = this.$getSelectedPotentialPromotion({
          startDate,
          endDate,
        }, validateSelectedPromotion);

        if (this.$isNotEmptyV2(selected)){
          if(selected.promotion_type === 'PROMO_CODE') params.promo_code = selected.promo_code
          else params.promotion_affected = selected.id

          if(selected.promotion_type === 'MEMBERSHIP'){
            const { id: rewardId } = selected.membership_reward.reward;
            params.membership_reward_id = rewardId;
          }
        } 
      }

      return params;
    },
    getParamsRoomListStayDate() {
      const { check_in, check_out } = this.getBeFilter.date;

      return {
        check_in_date: this.$formatDateApi(check_in),
        check_out_date: this.$formatDateApi(check_out),
      };
    },
    getParamsRoomListGuest() {
      const {
        search_room_is_show_filter_pax_child: useChild,
        search_room_is_show_filter_pax_infant: useInfant,
      } = this.getMerchant;

      const { adult, child, infant } = this.getBeFilter.guest;
      
      let params = {
        adult,
        child: useChild ? child : 0,
        infant: useInfant ? infant : 0,
      }

      if(!this.isNotLogin){
        params.user_id = this.getCurrentUser.id
      }
      
      return params;
    },
    getParamsRoomListPrice() {
      const isPriceEmpty = (price) => this.$isEmpty(price) || price === 0;

      return {
        price_min: isPriceEmpty(this.getBePrice[0]) ? '' : this.getBePrice[0],
        price_max: isPriceEmpty(this.getBePrice[1]) ? '' : this.getBePrice[1],
      };
    },
    getParamsRoomListMembership() {
      if (this.$isNotEmptyV2(this.getMembershipReferral)) {
        const { membership_referral_code, membership_reward_id } =
          this.getMembershipReferral;
        return { membership_referral_code, membership_reward_id };
      } else if (!this.isNotLogin) {
        const { id } = this.getMembershipRewardApplied;
        if(this.$isNotEmptyV2(id)){
          return { membership_reward_id: id };
        }
      }
      return {};
    },
    getParamsRoomListSpecificFilter() {
      if (!this.showSpecificFilter) return {};

      const {
        type,
        data: { id },
      } = this.getBeFilterDetail;
      return type === 'room_type' ? { room_type_id: id } : { rate_id: id };
    },
    parsedRoomData(rooms, roomAvailability) {
      this.room.list = rooms.map((roomType) => {
        roomType.room_rate = roomType.room_rate.map(
          (roomRate, roomRateIndex) => {
            const originalId = roomRate.id;
            roomRate.id_ori = originalId;
            roomRate.id = `${originalId}_${roomRateIndex}`;
            return roomRate;
          }
        );
        return roomType;
      });
      this.room.typeAvailabilty = roomAvailability.map((roomType) => {
        roomType.original_availability = roomType.availability;
        return roomType;
      });
      this.setBeRoomAvbl(this.room.typeAvailabilty);
    },
    resetAllFilter() {
      this.resetBeFilter();
      this.resetSelectedPromotion();
      this.loadRoomList();
    },
    getRoomAvlb(roomTypeId) {
      let roomAvlb = this.getBeRoomAvbl.find((room) => room.id == roomTypeId);
      return roomAvlb ? roomAvlb.original_availability : 0;
    },
    discountAccumulation(counter, base) {
      let display = ((base - counter) * 100) / base;
      return +parseFloat(display).toFixed(2);
    },
    totalRateBreakdown(data) {
      let total_price_breakdown = 0;
      for (let i = 0; i < data.length; i++) {
        total_price_breakdown += data[i].final_price;
      }
      return total_price_breakdown;
    },
    clearFilterDetail() {
      this.setBeFilterDetail({ type: 'room_type', data: {} });
      this.loadRoomList();
    },
    selectPromoCode(promotion) {
      const { promo_code } = promotion;
      this.setSpecificBeFilter([{ key: 'promo_code', value: promo_code }]);
      this.loadRoomList();
    },
    toggleBackdrop(show = false) {
      this.isBackdropActive = show;
      if (!show) {
        this.show_rate = false;
        this.show_rate_breakdown = false;
        this.is_booking_dropdown = false;
        this.mobilePopupType = '';
        this.showMoreRoomSelection = false;
      }
    },
    toggleRoomTypeDetail(data = {}) {
      this.roomTypeDetail = data;
      this.toggleBackdrop(this.$isNotEmptyV2(data) ? true : false);
    },
    toggleRoomRateDetail(data = {}) {
      this.mobilePopupType = data == '' ? 'close' : 'room_rate';
      this.roomRateDetail = data;
      this.toggleBackdrop(this.$isNotEmptyV2(data) ? true : false);
    },
    toggleRoomRateAdd(data = {}) {
      this.mobilePopupType = data == '' ? 'close' : 'room_rate_add';
      this.roomRateDetail = data;
      this.toggleBackdrop(this.$isNotEmptyV2(data) ? true : false);
    },
    toggleRateBreakdown(type, data) {
      if (type == 'rates') {
        if (this.show_rate == data) {
          this.show_rate = false;
          return;
        }
        this.show_rate = data;
        this.toggleBackdrop(true);
      } else if (type == 'rates-breakdown') {
        if (this.show_rate_breakdown == data) {
          this.show_rate_breakdown = false;
          return;
        }

        this.show_rate_breakdown = data;
        this.show_rate = data;
        this.toggleBackdrop(true);
      }
    },
    toggleBookingRate(data) {
      if (this.is_booking_dropdown == data) {
        this.is_booking_dropdown = '';
        this.toggleBackdrop(false);
      } else {
        this.is_booking_dropdown = data;
        this.toggleBackdrop(true);
      }
    },
    toggleBookingRateCart(type, data, qty = 1) {
      let room_selected = data;
      if (type == 'add') {
        if (this.is_booking_rate_cart.length == 0) {
          room_selected['qty'] = qty;
          this.is_booking_rate_cart.push(room_selected);
        } else {
          let is_exist = false;
          for (let i = 0; i < this.is_booking_rate_cart.length; i++) {
            if (room_selected.id == this.is_booking_rate_cart[i].id) {
              is_exist = i;
              break;
            }
          }
          if (is_exist === false) {
            room_selected['qty'] = qty;
            this.is_booking_rate_cart.push(room_selected);
          } else {
            this.is_booking_rate_cart[is_exist].qty = qty;
          }
        }
      } else {
        this.is_booking_rate_cart.splice(data, 1);
      }
      this.is_booking_dropdown = false;
      this.show_rate = false;
    },
    openMoreRoomInput(data) {
      this.mobilePopupType = 'room_rate';
      this.showMoreRoomSelection = true;
      this.roomRateDetail = data;
    },
  },
};
</script>
<style>
.preview-cart-desktop {
  position: sticky;
  top: 100px;
  z-index: 1039 !important;
}
.preview-cart-module-desktop {
  position: sticky;
  top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/be/SearchRoomWithMultiImageBanner.vue